import { Close } from '@mui/icons-material';
import { Modal } from '@mui/material';
import { Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useAlertView } from 'store/alert/selectors';
import { BirdLogo } from 'utils/assets/images';

const FeedBackWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
`;
const FeedbackContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 50%;
    min-height: 50%;
    background-color: rgb(58,58,58);
    position: relative;
    justify-content: center;
    padding: 20px;
    padding-top: 0px;

`;
const BirdLogoImg = styled.div`
    width: 270px;
    height: 180px;
    margin-top: 20px;
    background-image: url(${BirdLogo});
    background-position: top;
    background-size: 150% 130%;
    background-repeat: no-repeat;
`;

const CloseBtn = styled.div`
    background-color: rgb(204,80,71);
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 1;
`;

const AlertTitle = styled.div`   
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    text-align: center;
    text-transform: uppercase;
    white-space: pre-line;
    text-align: center;
    width: 100%;
    color: red;
    `;
const AlertMessage = styled.div`   
    color: white;
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 5px;
    text-align: center;
    text-transform: uppercase;
    white-space: pre-line;
    width: 100%;
    color: #fff;
    `;

const AlertViewModal = () => {
    const [alertView, , revokeAlertView] = useAlertView();
    if(!alertView.view) return null;
    return (
        <Modal
            open={alertView.view}
            onClose={revokeAlertView}
            style={{ height: '100%', width: '100%', backgroundColor: 'transparent' }}
        >
            <FeedBackWrapper>
                <FeedbackContainer>
                    <Row style={{ justifyContent: 'center' }}>
                        <BirdLogoImg />
                        <CloseBtn onClick={revokeAlertView}>
                            <Close style={{ color: '#fff', fontWeight: 'bolder', fontSize: 35 }} />
                        </CloseBtn>
                    </Row>
                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', flexDirection: 'column' }}>
                        <AlertTitle>{alertView.title}</AlertTitle>
                    </Row>
                    <Row style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                        {alertView.message ? <AlertMessage>{alertView.message}</AlertMessage> : null}
                    </Row>
                </FeedbackContainer>
            </FeedBackWrapper>
        </Modal>
    );
};

export default AlertViewModal;
